import { useState, useEffect, useMemo, useLayoutEffect } from 'react';
import Property from '../../constants/property'
import api from '../../apis';

import { useFilter } from '../../context/FilterContext';
import { numberWithCommas } from '../general/convertor';

const mapDesc:any = Property.accountSummaryType;


const ContraTbl = ({
    requestOnRender=false,
    handleClick = (id:string)=>{},
}:any) => {
   // const { initFilter,filterParams }:any = useGlobalVariable();
    const { filterParams } = useFilter();
    const [accountSummary,setAccountSummary] = useState<any>({});

    useEffect(() => {
        //console.log("filterParams",filterParams)
        handleFilter(filterParams)
       
    }, [filterParams]);

    const handleFilter = (filterParams:any)=>{
        if(Object.keys(filterParams).length == 0) return;

        requestAccountSummary(filterParams['accounts[]']);
    }


    // useEffect(() => {
    //     if(requestOnRender == true){
    //         //alert("requestOnRender")
    //         handleFilter(filterParams)
    //     }
        
    // }, [requestOnRender]);

    const requestAccountSummary = async (accounts:any)=>{

        setAccountSummary({})

        //if(accounts && accounts.length>0){
        let account_id = accounts[0];
        let accountSummaryResult = await api.getAccountSummary(account_id);
        //  console.log("requestAccountSummary response",accountSummaryResult);

        if(accountSummaryResult.length >0){

            let newSummary = handleAccountSummaryResult(accountSummaryResult);
            //   console.log('handleAccountSummaryResult',newSummary)
    
            setAccountSummary(newSummary)
        }
       // }
       

        // let getAccountFinancialList = await api.getAccountFinancialList("505",{},null);
        // console.log("getAccountFinancialList response",getAccountFinancialList)
    }

    const handleAccountSummaryResult = (result:any)=>{
        let newSummary:any = {};
        result.forEach((item:any)=>{
            let currency = item['c_code'];
            if(!newSummary[currency]) {
                newSummary[currency] =item;

                return;
            }else{
                //add with previous value
                let prev = newSummary[currency];

                const summedObject = sumObjects(prev, item);
                newSummary = summedObject;
            }


     
        })

        return newSummary;
    }

    const sumObjects = (obj1:any, obj2:any) => {
        const result:any = {};
        
        // Iterate through all properties of the first object
        for (const key in obj1) {
            if (obj1.hasOwnProperty(key)) {
                // If the value is a number, sum them
                if (typeof obj1[key] === 'number' && typeof obj2[key] === 'number') {
                    result[key] = obj1[key] + obj2[key];
                } else {
                    // Otherwise, use the value from the first object
                    result[key] = obj1[key];
                }
            }
        }
        
        return result;
    };




        //account summary row
        const RenderTableTr = (
            id="",
            onClickNav = false
            // desc="",
            // currency="",
            // os_amount=0,
            // myr_equivalent=0,
            // onClickId =""
        ):any =>{
            if(!mapDesc[id]) return <></>;
    
            let trRows:any = [];
            //loop each key in accountSummary 
            Object.keys(accountSummary).forEach((key,index) => {
                // console.log("index123 ",index)
                let currency = key;
                let item = accountSummary[key];
                let title = mapDesc[id];
                let descText = onClickNav
                ? 
                <div className='link' onClick={()=>handleClick(id)}>
                    {index == 0 ?title:""}
                </div>:<>{index == 0 ?title:""}</>;
    
                let os_amount = item[id] || 0;
                let myr_equivalent = item[id+"_baseccy"] || 0;

                if(os_amount == 0 && myr_equivalent == 0 && currency!="MYR") return;
    
                trRows.push(
                    <tr key={key}>
                        <td className="">{ descText }</td>
                        <td><div className='text-center'>{currency}</div></td>
                        <td><div className='text-right'>{numberWithCommas(os_amount,2)}</div></td>
                        <td><div className='text-right'>{numberWithCommas(myr_equivalent,2)}</div> </td>
                    </tr>
    
                )
            });
    
            return trRows;
        }
    
        const RenderTableBreakTr = ( title="" ):any =>{
            return (
                <tr >
                    <td colSpan={4} className='description-title'>{title}</td>
                </tr>
            )
        }


    return (
        <> 
            {/* <div>Username / Account No: </div> */}
            <table className="account-summary-table react-table small separate gap-md">
                <thead>
                    <tr>
                        <th className="description">Description</th>
                        <th className="currency">Currency</th>
                        <th className="amount">O/S Amount</th>
                        <th className="amount">MYR Equivalent</th>
                    </tr>
                </thead>

                <tbody>
                    {RenderTableTr("opening_trust",false)}
                    {RenderTableBreakTr("")}
                    {RenderTableTr("opening_limit",false)}
                    {RenderTableTr("intra_purchasesales",false)}
                    {RenderTableTr("intra_fpxdeposit",false)}
                    {RenderTableTr("available_limit",false)}

                    {RenderTableBreakTr("")}
                    {RenderTableBreakTr("Purchase")}
                    {RenderTableTr("due_for_forceselling",true)}
                    {RenderTableTr("due_for_settlement",true)}
                    {RenderTableTr("remaining_purchase_contracts",true)}

                    {RenderTableBreakTr("")}
                    {RenderTableBreakTr("Sales")}
                    {RenderTableTr("sales_proceed_due",true)}
                    {RenderTableTr("remaining_sales_contracts",true)}

                    {RenderTableBreakTr("")}
                    {RenderTableBreakTr("Contra")}
                    {RenderTableTr("contra_gains",true)}
                    {RenderTableTr("contra_losses",true)}

                    {RenderTableBreakTr("")}
                    {RenderTableTr("others",true)}

                    
                </tbody>
            </table>
        </>
    );
};

export default ContraTbl;
